import { useCallback, useRef, useState } from 'react'

let uploadIdCounter = 0

function useFileUploaderManager({ uploadUrl }) {
  const [uploads, setUploads] = useState([])
  const workersRef = useRef({})
  const startUploadMap = useRef({}) // Map of startUpload functions per operation

  const createUploader = useCallback(
    ({ mutation, operationName }) => {
      const startUpload = ({ files, recordId, headers }) => {
        const fileList = Array.from(files)

        const newUploads = fileList.map(file => {
          // eslint-disable-next-line no-plusplus
          const uploadId = ++uploadIdCounter
          const worker = new Worker(
            new URL('../workers/uploadWorker.js', import.meta.url)
          )
          workersRef.current[uploadId] = worker

          const uploadObj = {
            file,
            uploadId,
            operationName,
            recordId,
            progress: 0,
            status: 'Uploading'
          }

          worker.onmessage = e => {
            const { type, progress, uploadId: id, status: errorStatus } = e.data

            setUploads(prev =>
              prev.map(u =>
                u.uploadId === id
                  ? {
                    ...u,
                    progress: type === 'progress' ? progress : u.progress,
                    status:
                        // eslint-disable-next-line no-nested-ternary
                        type === 'success'
                          ? 'Completed'
                          : type === 'error'
                            ? `Failed (${errorStatus || 'Network error'})`
                            : u.status
                  }
                  : u
              )
            )

            if (type === 'success' || type === 'error') {
              worker.terminate()
              delete workersRef.current[id]
            }
          }

          const variables = {
            id: recordId,
            input: {
              file,
              generateNote: false,
              saveAudioFile: true
            }
          }

          worker.postMessage({
            file,
            uploadUrl,
            uploadId,
            headers,
            mutation,
            variables,
            operationName
          })

          return uploadObj
        })

        setUploads(prev => [...prev, ...newUploads])
      }

      startUploadMap.current[operationName] = startUpload
    },
    [uploadUrl]
  )

  return {
    uploads,
    createUploader,
    getUploader: operationName => startUploadMap.current[operationName]
  }
}

export default useFileUploaderManager
